<!-- Modal Backdrop -->
@if (isOpen) {
  <div
    class="fixed inset-0 overflow-y-auto"
    [class]="overlayZIndexClass + ' transition-opacity duration-300 ' + (isOpen ? 'opacity-100' : 'opacity-0')"
  >
    <!-- Backdrop -->
    <div 
      class="fixed inset-0 backdrop-blur-sm backdrop-brightness-95 bg-black bg-opacity-50 transition-opacity"
      (click)="onBackdropClick($event)"
    ></div>

    <!-- Modal Container -->
    <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
      <!-- Modal Panel -->
      <div
        class="relative transform max-w overflow-visible rounded-lg bg-white text-left shadow-xl transition-all duration-300 w-full max-h-[90vh] flex flex-col"
        [class]="modalSizeClass + ' ' + customClass"
        [class.opacity-100]="isOpen"
        [class.scale-100]="isOpen"
        [class.opacity-0]="!isOpen"
        [class.scale-95]="!isOpen"
        (click)="$event.stopPropagation()"
      >
        <!-- Modal Header -->
        @if (title || showCloseButton) {
          <div class="px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex-shrink-0">
            <div class="flex items-center justify-between">
              <!-- Title -->
              @if (title) {
                <h3 class="text-lg font-bold leading-6 text-[#6729FF] pr-4">
                  {{ title }}
                </h3>
              }

              <!-- Close Button -->
              @if (showCloseButton) {
                <button
                  type="button"
                  class="rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200"
                  (click)="closeModal()"
                  aria-label="Close modal"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              }
            </div>
          </div>
        }

        <!-- Modal Content -->
        <div class="mb-3 mt-3 px-4 pb-4 pt-5 sm:p-6 sm:pt-0 overflow-y-auto overflow-x-hidden flex-1 min-h-0" [class]="contentClass">
          <ng-content></ng-content>
        </div>

        <!-- Modal Footer (optional) -->
        @if (false) {
          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <!-- Footer content can be projected here if needed -->
            <ng-content select="[slot=footer]"></ng-content>
          </div>
        }
      </div>
    </div>
  </div>
}

